function cov_16zlq2rs99() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DocumentCheckFilled.tsx";
  var hash = "9d705e2a782c7a80cc3c448624deeea13c69f310";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DocumentCheckFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 61
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9d705e2a782c7a80cc3c448624deeea13c69f310"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_16zlq2rs99 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_16zlq2rs99();
var Icon = (cov_16zlq2rs99().s[0]++, {
  name: 'document-check-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 22L5 22C3.34315 22 2 20.6569 2 19V10L8.5 10C9.60457 10 10.5 9.10457 10.5 8V2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22ZM16.2071 11.7071C16.5976 11.3166 16.5976 10.6834 16.2071 10.2929C15.8166 9.90237 15.1834 9.90237 14.7929 10.2929L11 14.0858L9.20711 12.2929C8.81658 11.9024 8.18342 11.9024 7.79289 12.2929C7.40237 12.6834 7.40237 13.3166 7.79289 13.7071L11 16.9142L16.2071 11.7071Z\" fill=\"currentColor\"/>\n  <path d=\"M7.5 2H8.5L8.5 8L2 8L7.5 2Z\" fill=\"currentColor\"/>"
});
export default Icon;